import { useState } from "react";
import { EvidenceCard } from "./EvidenceCard";
import { DataTable } from "@/components/DataTable";
import { AcosPill } from "@/components/Pills";
import { fmtMoney, fmtNum } from "@/lib/format";

const TABS = [
  { key: "b3", label: "3+ orders" },
  { key: "b2", label: "2 orders" },
  { key: "b1", label: "1 order" },
];

export const ConvertingTermsSection = ({ data, cur, badge, footnote }) => {
  const [tab, setTab] = useState(() => {
    for (const t of TABS) if ((data?.[t.key] || []).length > 0) return t.key;
    return "b3";
  });
  const rows = data?.[tab] || [];

  return (
    <EvidenceCard id="convertingTerms" title="Converting search terms" badge={badge} badgeColor="#0d0d0d" footnote={footnote}>
      <p className="text-sm text-[color:var(--grey)] mt-1 mb-4 max-w-2xl">
        Every search term that made an order in the window, grouped by how many.
      </p>
      <div className="flex gap-0 border-2 border-[color:var(--ink)] w-fit my-4" data-testid="converting-terms-tabs">
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            data-testid={`converting-terms-tab-${t.key}`}
            className={`px-4 py-2.5 ss-mono text-[11px] font-semibold uppercase tracking-[0.14em] transition-colors ${
              tab === t.key ? "bg-[color:var(--ink)] text-white" : "bg-white text-[color:var(--grey)] hover:text-[color:var(--ink)]"
            }`}
          >
            {t.label}
            <span className="ml-2 text-[10px] opacity-70 tabular-nums">
              {fmtNum((data?.[t.key] || []).length)}
            </span>
          </button>
        ))}
      </div>
      <DataTable
        testId={`converting-terms-table-${tab}`}
        cap={15}
        rows={rows}
        columns={[
          { key: "term", label: "Search term" },
          { key: "spend", label: "Spend", align: "right", render: (r) => fmtMoney(cur, r.spend) },
          { key: "sales", label: "Sales", align: "right", render: (r) => fmtMoney(cur, r.sales) },
          { key: "orders", label: "Orders", align: "right", render: (r) => fmtNum(r.orders) },
          { key: "clicks", label: "Clicks", align: "right", render: (r) => fmtNum(r.clicks) },
          { key: "acos", label: "ACoS", align: "right", render: (r) => <AcosPill value={r.acos} /> },
          {
            key: "matchClasses",
            label: "Match",
            render: (r) => (r.matchClasses || []).join(", ") || "—",
          },
        ]}
      />
    </EvidenceCard>
  );
};
